import { Binding, TABLE } from '@adalo/constants'
import { IObject } from 'interfaces'
import { traverse } from 'utils/treeTraversal'

interface HasObjects<O extends IObject, B extends Binding> {
  id?: string
  name?: string
  type?: string
  objects: O[]
  dataBindings?: Record<string, B>
}

export const isDependencyForTableObject = (
  screen: HasObjects<any, any>,
  dependency: any
) => {
  const tableChildren: IObject[] = []
  traverse(screen.objects, obj => {
    if (obj.type === TABLE) {
      tableChildren.push(obj)
    }
  })

  const tableChildrenIds = tableChildren.map(table => table.id)

  // If a dependency is a binding for a table object, it will have the table objectId in its bindingId
  const isTableDependency = tableChildrenIds.some(
    id =>
      dependency?.bindingId === id ||
      dependency?.bindingId?.includes?.(id) ||
      dependency?.bindingIds?.includes?.(id)
  )

  return isTableDependency
}
